import React from 'react';
import { Chip, Stack, Typography } from '@mui/material';
import { ListChecks } from 'lucide-react';

export default function EventTaskChips({ links = [] }) {
  const tasks = links.map((link) => link.task).filter(Boolean);

  if (!tasks.length) return null;

  return (
    <Stack spacing={1} alignItems="flex-start">
      <Stack direction="row" spacing={0.75} alignItems="center" sx={{ color: 'secondary.main' }}>
        <ListChecks size={17} />
        <Typography variant="caption" sx={{ color: 'secondary.main' }}>
          Tasks to do
        </Typography>
      </Stack>
      <Stack direction="row" gap={1} flexWrap="wrap">
        {tasks.map((task) => (
          <Chip
            key={task.id}
            size="small"
            label={task.title || 'Task'}
            variant="outlined"
            sx={(theme) => ({
              color: theme.palette.primary.main,
              borderColor: theme.palette.orange.main,
              bgcolor: `${theme.palette.orange.main}12`,
              maxWidth: '100%',
              '& .MuiChip-label': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              },
            })}
          />
        ))}
      </Stack>
    </Stack>
  );
}
